const state = {
  all: [],
  atual: {
    id: 0,
    nometurno: 'Não cadastrado',
    horainicio: '--:--',
    horafim: '--:--',
    created_at: '',
    updated_at: ''
  }
}

const mutations = {
  addTurnosList (state, res) {
    state.all.push(res.data)
  },
  updateTurnosList (state, res) {
    state.all = res.data
  },
  updateTurnoAtual (state, res) {
    state.atual = res.data
  }
}

const actions = {
  createTurno (context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/turnos', data).then((res) => {
      context.commit('addTurnosList', res)
      return res
    })
  },
  updateTurno (context, data) {
    var id = data.id
    let qs = require('querystring')
    var dados = qs.stringify(data.turno)
    return window.axios.put('/api/v2/turnos/' + id, dados).then((res) => {
      return res
    })
  },
  deleteTurno (context, id) {
    return window.axios.delete('/api/v2/turnos/' + id).then((res) => {
      return res
    })
  },
  listTurnos(context) {
    return window.axios.get('/api/v2/turnos').then((res) => {
      context.commit('updateTurnosList', res)
      return res
    })
  },
  turnoAtual(context) {
    return window.axios.get('/api/v2/turnos/data/atual').then((res) => {
      context.commit('updateTurnoAtual', res)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Turnos.js